import { render, staticRenderFns } from "./WeChat.vue?vue&type=template&id=4772d959&scoped=true&"
import script from "./WeChat.vue?vue&type=script&lang=js&"
export * from "./WeChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772d959",
  null
  
)

export default component.exports